import React, { Component } from "react";
import { connect } from "react-redux";
import BookingPortal from "../../modules/BookingPortal";
import ContactForm from "../../modules/ContactForm";
import Confirm from "../../modules/Confirm";
import { Spinner } from "../../../src/modules/BookingPortal/components/Shared/Spinner";
import PageLayout from "../../modules/Layout";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import { customTheme } from "./theme";

const muiTheme = getMuiTheme(customTheme);

class App extends Component {
  renderPage = () => {
    const { page } = this.props;

    switch (page.toLowerCase()) {
      case "booking":
        return <BookingPortal />;

      case "contactform":
        return <ContactForm />;

      case "confirm":
        return <Confirm />;

      default:
        return <BookingPortal />;
    }
  };

  render() {
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <PageLayout location={this.props.location}>
          <Spinner spinning={this.props.loading} />
          {this.renderPage()}
        </PageLayout>
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = state => {
  return { loading: state.booking.loading, page: state.booking.page };
};
export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App/index.js